/* IB2 — scroll-reveal (safe). Sections are visible by default. We only hide
   sections that are currently BELOW the fold, then fade them in as they scroll
   into view. If this script never runs, everything stays visible. */
(function () {
  function setup() {
    if (!('IntersectionObserver' in window)) return; // leave everything visible
    var els = document.querySelectorAll(
      'main .shopify-section:not(.hero-section):not(.info-strip-section)'
    );
    if (!els.length) return;

    var vh = window.innerHeight || document.documentElement.clientHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-revealed');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (e) {
      // Only animate sections that start well below the fold — anything already
      // visible (or near it) is left untouched, so there's never a blank screen.
      if (e.getBoundingClientRect().top > vh * 0.85) {
        e.classList.add('reveal-pending');
        io.observe(e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
